// マシン一覧から選択時にview書き換え
$(document).on ('change', '#room-error-machine-selector', () => {
  path = $('#room-error-machine-selector').find('option:selected').data('path')
  selected_val = $('#room-error-machine-selector').find('option:selected').val()
  path = path + `?filter=room&selected_val=${selected_val}`
  if (path != null) {
    window.location.href = path
  }
})
